/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/car_1'
export default icon
